import type { Logger } from '@datadog/browser-logs';
import type { UserDetails } from '@thinkalpha/ui-types/types/user';
import type { LDEvaluationDetail } from 'launchdarkly-js-sdk-common';

export interface DatadogService {
    setUserDetails(user?: UserDetails): void;
    submitErrorToDatadog(error: Error, context?: object): void;
    submitActionToDatadog(actionType: string, context?: object): void;
    addFeatureFlagEvaluation(key: string, value: LDEvaluationDetail): void;
    logger: Logger;
}

export const MASKED_KEYS = ['password', 'token', 'accessToken', 'refreshToken', 'masqAccessToken', 'masqToken'];

function maskLog(log: Record<string, unknown>): void {
    for (const key in log) {
        if (MASKED_KEYS.includes(key) && typeof log[key] === 'string') {
            log[key] = '[***]';
        } else if (typeof log[key] === 'object' && log[key] !== null) {
            maskLog(log[key] as Record<string, unknown>);
        }
    }
}

export function createLogBeforeSend(additionalFilter?: (log: any) => boolean | void) {
    return (log: any): boolean => {
        const statusCode = log.http?.status_code;
        // Do not log pure network failures (status 0 / origin network); they are client connectivity issues
        // already surfaced to the user and not actionable in backend telemetry.
        if (statusCode === 0) {
            return false;
        }
        if (additionalFilter && additionalFilter(log) === false) {
            return false;
        }
        maskLog(log);
        return true;
    };
}
